
'use strict';

var $ = require('jquery'),
  EngineerSupportView = require('./../Engineer/EngineerSupportView'),
  EngineerListingView = require('../Engineer/EngineerListingView'),
  MyProjectListingView = require('./MyProjectListingView');

import {ProjectsService} from '../../services/ProjectsService';

export const projectsController = ProjectsService.getInstance();

export function createEngineersList() {
  let $engineersList = $('.Engineers-list');
  let $engineersListLoadMore = $('.EngineerList-loadMore');
  if ($engineersList.length) {
    new EngineerSupportView({ el: $engineersList[0] });
  }
  if ($engineersListLoadMore.length) {
    new EngineerListingView({ el: $engineersListLoadMore[0] });
  }
}

export function createMyProjectsListing() {
  let $myProjectsListing = $('.MyProjectsListing');
  if ($myProjectsListing.length) {
    new MyProjectListingView({ el: $myProjectsListing[0] });
  }
}




// WEBPACK FOOTER //
// ./assets/components/DesignCenter/design-center.js